import {
  CheckmarkFilled,
  ErrorFilled,
  InformationFilled,
  WarningFilled,
} from '@carbon/icons-react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { cx } from 'lib/cx'
import type { ReactNode } from 'react'
import type { Toast } from 'react-hot-toast/headless'
import { toast as toastHook } from 'react-hot-toast/headless'

export type NotificationType = 'success' | 'error' | 'info' | 'warning'
export type NotificationProps = {
  toast: Omit<Toast, 'type'> & { type: NotificationType }
}
export default function Notification({ toast }: NotificationProps) {
  const { type } = toast
  return (
    <div className="text-text-primary w-72 bg-white shadow-sm">
      <div
        className={cx(
          'border-l-4',
          type === 'success' && 'border-support-green bg-support-green/10',
          type === 'error' && 'border-support-error bg-support-error/10',
          type === 'info' && 'border-support-info bg-support-info/10',
          type === 'warning' && 'border-support-warning bg-support-warning/10',
        )}
      >
        <div className="flex p-4">
          <div className="shrink-0">
            {type === 'success' && (
              <CheckmarkFilled
                className="text-support-green h-5 w-5"
                aria-hidden="true"
              />
            )}
            {type === 'error' && (
              <ErrorFilled
                className="text-support-error h-5 w-5"
                aria-hidden="true"
              />
            )}
            {type === 'info' && (
              <InformationFilled
                className="text-support-info h-5 w-5"
                aria-hidden="true"
              />
            )}
            {type === 'warning' && (
              <WarningFilled
                className="text-support-warning h-5 w-5"
                aria-hidden="true"
              />
            )}
          </div>
          <div className="ml-3">{toast.message as ReactNode}</div>
          <div className="ml-auto pl-3">
            <div className="">
              <button
                type="button"
                className=""
                onClick={() => toastHook.remove(toast.id)}
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
